/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".screening-error-action[_ngcontent-%COMP%]{text-align:right}.screening-error-list[_ngcontent-%COMP%]{margin:0;padding:17px}.screening-error-list-name[_ngcontent-%COMP%]{font-size:120%}.screening-error-list-errors[_ngcontent-%COMP%]{margin-bottom:5px}"];
export { styles as styles };
